import Vue from "vue";
import moment from "moment";

export default {
  namespaced: true,
  state: {
    initialized: false,
    donations: null,
    monthlyCosts: 5,
    annualCosts: 13,
    startDate: "2020-04-08"
  },
  mutations: {
    /**
     * Internal use, prevent double-setup ws listeners
     * @param {*} state
     * @param {*} value
     */
    setInitialized(state, value) {
      state.initialized = value;
    },
    setDonations(state, dontations) {
      state.donations = {};

      dontations.forEach(donation => {
        Vue.set(state.donations, donation.id, donation);
      });
    },
    updateDonation(state, donation) {
      var d = state.donations[donation.id];
      if (d) {
        d.value = parseFloat(donation.value);
      }
    }
  },
  actions: {
    /**
     * Runs only once (when not initialized),
     * sets up all the necessary topquiz handlers to manage this store
     * @param {*} me
     * @param {*} vm
     */
    storeCreated(me, vm) {
      if (me.state.initialized === true) {
        return;
      }

      me.commit("setInitialized", true);

      vm.$topquiz.on(this, "getDonationInfo_success", params => {
        var donations = params[0];
        var currentCosts = me.getters.currentCosts;
        donations.forEach(item => {
          if (item.max == -1) {
            item.max = currentCosts;
          }
          item.description = item.description.replace("{goal}", currentCosts);
        });
        me.commit("setDonations", donations);
      });

      vm.$topquiz.on(this, "donationChanged", params => {
        var donation = { id: params[0], value: params[1] };
        me.commit("updateDonation", donation);
      });
    },
    /**
     * Loads all public quizzes from the database, replacing the old ones
     * @param {*} me
     * @param {*} vm
     */
    loadDonations(me, vm) {
      me.dispatch("storeCreated", vm);
      vm.$topquiz.sendCommand("getDonationInfo");
    }
  },
  getters: {
    currentCosts(state) {
      var start = moment(state.startDate, "YYYY-MM-DD");
      var yearsSinceStart = Math.ceil(moment().diff(start, "years", true));
      var monthsSinceStart = Math.ceil(moment().diff(start, "months", true));

      return (
        yearsSinceStart * state.annualCosts +
        monthsSinceStart * state.monthlyCosts
      );
    }
  }
};
